import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useHistory } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import Loader from '../../Components/Utility/Loader/Loader';
import { ssoTicketLogin } from '../../services/auth.service';

const LOGIN_ERROR_PATH = '/login?sso_error=1';

function SsoComplete() {
  const { t } = useTranslation('sso');
  const location = useLocation();
  const history = useHistory();
  const startedRef = useRef(false);
  const [welcomeUser, setWelcomeUser] = useState(null);

  const enterApp = () => {
    window.location.href = `${window.location.origin}/todo-list/my-todo`;
  };

  useEffect(() => {
    if (startedRef.current) {
      return;
    }
    startedRef.current = true;
    const ticket = new URLSearchParams(location.search).get('ticket');

    const completeLogin = async () => {
      if (!ticket) {
        if (localStorage.getItem('loggedInUserInfo')) {
          enterApp();
          return;
        }
        history.replace(LOGIN_ERROR_PATH);
        return;
      }
      try {
        const response = await ssoTicketLogin({ ticket });
        if (response?.code === 200 && response?.data?.token) {
          const previousStates = {
            libraries: '',
            'account-settings': '',
          };
          localStorage.setItem('loggedInUserInfo', JSON.stringify(response.data));
          localStorage.setItem('previousStates', JSON.stringify(previousStates));
          history.replace(location.pathname);
          if (response.data.ssoFirstLogin) {
            setWelcomeUser(response.data);
            return;
          }
          enterApp();
          return;
        }
        history.replace(LOGIN_ERROR_PATH);
      } catch (error) {
        history.replace(LOGIN_ERROR_PATH);
      }
    };
    completeLogin();
  }, [location.search, history]);

  if (welcomeUser) {
    return (
      <Modal show centered backdrop="static" keyboard={false}>
        <Modal.Header>
          <Modal.Title>{t('LOGIN.SSO_WELCOME_TITLE', { firstName: welcomeUser.firstName || '' })}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{t('LOGIN.SSO_WELCOME_ROLE', { role: welcomeUser.role || 'User' })}</p>
          <p>{t('LOGIN.SSO_WELCOME_PERMISSIONS')}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" className="btn-theme" onClick={enterApp}>
            {t('LOGIN.SSO_WELCOME_CONTINUE')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  return (
    <div className="text-center mt-40">
      <Loader />
    </div>
  );
}

export default SsoComplete;
